import { useState } from 'react';
import { supabase } from '../lib/supabase';

export type FeedbackType = 'interested' | 'not-interested' | 'suggestions';

export interface FeedbackData {
  type: FeedbackType;
  role: string;
  thoughts: string;
}

export function useFeedback() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submitFeedback = async (data: FeedbackData) => {
    try {
      setIsSubmitting(true);
      setError(null);

      const { error: submitError } = await supabase
        .from('feedback')
        .insert([data]);

      if (submitError) {
        console.error('Supabase error:', submitError);
        throw new Error('Ett fel uppstod när feedbacken skulle sparas. Försök igen senare.');
      }

      return true;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Ett fel uppstod. Försök igen senare.');
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { submitFeedback, isSubmitting, error };
}